import axios from "axios";
import { ZBNI_BACKEND_API_ENDPOINT } from "app/config/constants";

export const backendHttpClient = axios.create({
  baseURL: ZBNI_BACKEND_API_ENDPOINT + "v1",
});

export const zapierClient = axios.create({
  transformRequest: [(data) => JSON.stringify(data)],
});
